import { render, staticRenderFns } from "./BeneficioHistorico.vue?vue&type=template&id=04198cd2&scoped=true&"
import script from "./BeneficioHistorico.vue?vue&type=script&lang=js&"
export * from "./BeneficioHistorico.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioHistorico.vue?vue&type=style&index=0&id=04198cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04198cd2",
  null
  
)

export default component.exports